import React from 'react';
import { Link } from 'gatsby';
import LitImage from './images/LitImage';
import LitStructuredText from './generic/LitStructuredText';
const InstallationSteps = ({ data, mode }) => {
  return (
    <>
      {/* PurgeCSS include:  BlackMode, YellowMode, WhiteMode*/}
      <div className={`installation-steps-container ${mode}Mode`}>
        {data?.map(
          ({ heading, copy, buttonText, buttonPath, image }, index) => {
            return (
              <div className="installation-steps-inner" key={index}>
                <div className="installation-steps-content">
                  <div className="installation-steps-title">
                    <LitStructuredText data={heading} basic />
                  </div>
                  <div className="installation-steps-body">
                    <LitStructuredText data={copy} basic />
                  </div>
                  {buttonText && <Link to={buttonPath}>{buttonText}</Link>}
                </div>
                <div className="installation-steps-image">
                  <LitImage image={image} alt="fibre installation step" />
                </div>
              </div>
            );
          },
        )}
      </div>
    </>
  );
};

export default InstallationSteps;
